import z from 'zod';

export const userFilterSchema = z.object({
    filterName: z.string(),
    ordinal: z.number().int(),
    isCustom: z.boolean().default(false),
    isDefault: z.boolean().default(false),
});

export const userFiltersSchema = z.object({
    id: z.string().nullable().default(''),
    filters: z.array(userFilterSchema).default([]),
});

export const saveUserFiltersResponseSchema = z.object({
    id: z.string().nullable().optional(),
});

export type UserFilter = z.infer<typeof userFilterSchema>;
export type UserFilters = z.infer<typeof userFiltersSchema>;
export type SaveUserFiltersResponse = z.infer<typeof saveUserFiltersResponseSchema>;
